import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/** Access = Director (always) or user with explicit can_view_pricing_catalog grant. */
export function PricingCatalogGuard() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/auth/login" replace />;
  if (!user.has_view_pricing_catalog_permission) return <Navigate to="/" replace />;
  return <Outlet />;
}
